import "core-js/modules/es6.math.trunc";
import "core-js/modules/es6.number.is-finite";
import "core-js/modules/es6.number.constructor";
/**
 * ============================================================
 * 国际专区课程封面解析
 * ------------------------------------------------------------
 * 职责: 按课程分类与课程序号解析本地封面图, 供课程卡片与课程详情复用
 * 背景: 后端课程可能未配置 coverUrl, 演示课程也没有远端封面;
 *       统一回退到本地分类封面, 避免出现空白封面
 * 区分: 同一分类提供 3 套同色系不同图形封面, 按课程主键稳定分配,
 *       避免同类课程封面完全一样
 * 兼容: 同时支持后端分类 key (zhinengzhizao) 与早期短 key (smart)
 * 创建日期: 2026-09-29
 * ============================================================
 */

var CATEGORY_COVERS = {
  zhinengzhizao: [require('@/assets/img/intl-covers/zhinengzhizao-1.svg'), require('@/assets/img/intl-covers/zhinengzhizao-2.svg'), require('@/assets/img/intl-covers/zhinengzhizao-3.svg')],
  shuzijishu: [require('@/assets/img/intl-covers/shuzijishu-1.svg'), require('@/assets/img/intl-covers/shuzijishu-2.svg'), require('@/assets/img/intl-covers/shuzijishu-3.svg')],
  xiandaifuwu: [require('@/assets/img/intl-covers/xiandaifuwu-1.svg'), require('@/assets/img/intl-covers/xiandaifuwu-2.svg'), require('@/assets/img/intl-covers/xiandaifuwu-3.svg')],
  jiaotongyunshu: [require('@/assets/img/intl-covers/jiaotongyunshu-1.svg'), require('@/assets/img/intl-covers/jiaotongyunshu-2.svg'), require('@/assets/img/intl-covers/jiaotongyunshu-3.svg')],
  caijingshangmao: [require('@/assets/img/intl-covers/caijingshangmao-1.svg'), require('@/assets/img/intl-covers/caijingshangmao-2.svg'), require('@/assets/img/intl-covers/caijingshangmao-3.svg')],
  wenhuayishu: [require('@/assets/img/intl-covers/wenhuayishu-1.svg'), require('@/assets/img/intl-covers/wenhuayishu-2.svg'), require('@/assets/img/intl-covers/wenhuayishu-3.svg')]
};

// 早期短 key -> 后端分类 key
var LEGACY_KEYS = {
  smart: 'zhinengzhizao',
  digital: 'shuzijishu',
  service: 'xiandaifuwu',
  transport: 'jiaotongyunshu',
  business: 'caijingshangmao',
  culture: 'wenhuayishu'
};

// 取出可用于样式与图标的规范分类 key
export function normalizeCategory(category) {
  if (!category) return '';
  return LEGACY_KEYS[category] || category;
}

// 明显异常的远端封面 — 测试期从剪贴板直接上传的截图, 尺寸比例与卡片完全不符
var TEST_COVER_PATTERN = /codex[-_]?clipboard|codex[_-]/i;

// 判断远端封面是否可用 — 测试性文件名视为不可用, 回退本地分类封面
function isUsableRemoteCover(url) {
  if (!url) return false;
  return !TEST_COVER_PATTERN.test(String(url));
}

// 按课程主键稳定挑选同类封面变体 — 同类课程连续主键会自然错开
function pickVariant(covers, course) {
  if (!covers || !covers.length) return '';
  var seed = Number(course && course.id);
  var index = Number.isFinite(seed) ? Math.abs(Math.trunc(seed)) % covers.length : 0;
  return covers[index] || covers[0];
}

// 解析课程封面图 — 有远端封面优先, 否则回退本地分类封面, 未知分类返回空
export function resolveCourseCover(course) {
  if (course && isUsableRemoteCover(course.coverUrl)) return course.coverUrl;
  var key = normalizeCategory(course && course.category);
  return pickVariant(CATEGORY_COVERS[key], course);
}